import { render, staticRenderFns } from "./ihuberr.vue?vue&type=template&id=5b81eb27&scoped=true&"
import script from "./ihuberr.vue?vue&type=script&lang=js&"
export * from "./ihuberr.vue?vue&type=script&lang=js&"
import style0 from "./ihuberr.vue?vue&type=style&index=0&id=5b81eb27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81eb27",
  null
  
)

export default component.exports